import React from 'react';
import {
    TextField,
    Autocomplete,
    IconButton,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

const SearchFilters = ({
    search,
    setSearch,
    market,
    setMarket,
    integrationType,
    setIntegrationType,
    marketList,
    integrationTypeList,
}) => {
    return (
        <div className="search-box">
            <TextField
                label="Server ID / Product Name"
                value={search}
                onChange={(e) => setSearch(e.target.value)}
                variant="outlined"
                InputProps={{
                    endAdornment: search && (
                        <IconButton onClick={() => setSearch("")}>
                            <CloseIcon />
                        </IconButton>
                    ),
                }}
            />

            <Autocomplete
                options={marketList}
                getOptionLabel={(option) => option}
                value={market}
                onChange={(e, newValue) => setMarket(newValue)}
                renderInput={(params) => (
                    <TextField {...params} label="Market" variant="outlined" />
                )}
            />

            <Autocomplete
                options={integrationTypeList}
                getOptionLabel={(option) => option}
                value={integrationType}
                onChange={(e, newValue) => setIntegrationType(newValue)}
                renderInput={(params) => (
                    <TextField {...params} label="Integration Type" variant="outlined" />
                )}
            />
        </div>
    );
};

export default SearchFilters;